import { succeed, field, array, string, Decoder, oneOf, stringLiteral } from 'jsonous';
import { FilterOption, FilterOptionsPayload, ShowUnlicensedToggle } from './FilterOptionsTypes';

const filterOptionDecoder: Decoder<FilterOption> = succeed({})
  .assign('value', field('value', string))
  .assign('label', field('label', string));

const showUnlicensedToggleDecoder: Decoder<ShowUnlicensedToggle> = oneOf([
  stringLiteral<ShowUnlicensedToggle>('show'),
  stringLiteral<ShowUnlicensedToggle>('hide'),
]);

const filterOptionsPayloadDecoder: Decoder<FilterOptionsPayload> = succeed({})
  .assign('product_type_options', field('product_type_options', array(filterOptionDecoder)))
  .assign('duration_options', field('duration_options', array(filterOptionDecoder)))
  .assign('school_partner_options', field('school_partner_options', array(filterOptionDecoder)))
  .assign('language_options', field('language_options', array(filterOptionDecoder)))
  .assign('license_options', field('license_options', array(filterOptionDecoder)))
  .assign('show_unlicensed_toggle', field('show_unlicensed_toggle', showUnlicensedToggleDecoder));

export const filterOptionsResourceDecoder: Decoder<FilterOptionsPayload> = field(
  'payload',
  filterOptionsPayloadDecoder,
);
